import { LIBRARY_TREE, LIBRARY_ALL_DATA } from "../actions/library.action";

const INITIAL_STATE = {
   libraryTree: {
      data: [],
      loading: true,
   },
   libraryData: {
      loading: true,
      data: [],
   },
};

export default function patientlist(state = INITIAL_STATE, action) {
   switch (action.type) {
      case LIBRARY_TREE:
         return {
            ...state,
            libraryTree: action.payload,
         };
      case LIBRARY_ALL_DATA:
         return {
            ...state,
            libraryData: action.payload,
         };
      default:
         return state;
   }
}
